<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                {value: null, text: $t('all')},
                {value: 1, text: $t('submit')},
                {value: 2, text: $t('confirmed')},
                {value: 3, text: $t('canceled')},
                {value: 4, text: $t('finish')}
            ]"></form-select>

            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-1" :defaultShortcut="8" />

            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>

        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('callInfo') }}</div>
            <div class="col-lg-4">{{ $t('leftOne') }}</div>
            <div class="col-lg-4">{{ $t('rightOne') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <p>
                <font-awesome-icon :class="iconClass(item.call)" size="2x" :icon="icon(item.call)" />
                {{ $t(item.call.direction) }} | <span>{{ item.call.hangupCause }}</span>
              </p>
              <p>
                <b>ID:&nbsp;</b><span>{{ item.call._id.toString() }}</span>
              </p>
              <p>
                <b>{{ $t('duration') }}:&nbsp;</b><span>{{ item.call.duration | callDuration }}</span>
              </p>
              <p>
                <b>{{ $t('billDuration') }}:&nbsp;</b><span>{{ item.call.billDuration | callDuration }}</span>
              </p>
              <app-audio v-if="item.call.recordingDownloaded" :id="item.call._id" :duration="item.call.duration" />
            </div>
            <div class="col-lg-4">
              <template v-if="getType(item, 'left')">
                <div v-if="getType(item, 'left').submitTime">
                  <b>{{$t('submitTime')}}: </b> {{getType(item, 'left').submitTime | moment('DD/MM/YYYY HH:mm:ss')}}
                </div>
                <template v-if="getType(item, 'left').confirmTime" >
                  <div>
                    <b>{{$t('confirmTime')}}: </b> {{getType(item, 'left').confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <div v-if="getType(item, 'left').approveBy" >
                    <b>{{$t('confirmBy')}}: </b> {{getType(item, 'left').approveBy.name}}
                  </div>
                </template>
                <template v-if="getType(item, 'left').cancelTime" >
                  <div>
                    <b>{{$t('cancelTime')}}: </b> {{getType(item, 'left').cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <div v-if="getType(item, 'left').approveBy" >
                    <b>{{$t('cancelBy')}}: </b> {{getType(item, 'left').approveBy.name}}
                  </div>
                </template>
                <div>
                  <span v-if="getType(item, 'left').cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
                  <span v-else-if="getType(item, 'left').confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
                  <span v-else-if="getType(item, 'left').submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
                  <span v-else class="mr-1 badge badge-warning">{{$t("doing")}}</span>

                  <span v-if="getType(item, 'left').note" class="text-gray-999 small" >{{getType(item, 'left').note}}</span>
                </div>
                <div v-if="getType(item, 'left').transcripts && getType(item, 'left').transcripts.length">
                  <div :class="[(getType(item, 'left').transcripts.join(', ').length <= 120 && getType(item, 'left').transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                    <div class="c-voice-text__content" v-html="getTranscripts(item, 'left')" ></div>
                    <div v-if="getType(item, 'left').transcripts.join(', ').length > 120 || getType(item, 'left').transcripts.length > 5" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                      <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                      <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                    </div>
                  </div>
                </div>
                <div class="mt-2" v-if="!item.finishTime && !getType(item, 'left').confirmTime">
                  <button type="button" class="btn btn-sm btn-primary mr-1" @click="update(getTypeString(item, 'left'), item)">
                    <i class="fa fa-edit mr-0"></i>
                    {{$t("edit")}}
                  </button>
                </div>
              </template>
            </div>
            <div class="col-lg-4">
              <template v-if="getType(item, 'right')"  >
                <div v-if="getType(item, 'right').submitTime" >
                  <b>{{$t('submitTime')}}: </b> {{getType(item, 'right').submitTime | moment('DD/MM/YYYY HH:mm:ss')}}
                </div>
                <template v-if="getType(item, 'right').confirmTime" >
                  <div>
                    <b>{{$t('confirmTime')}}: </b> {{getType(item, 'right').confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <div v-if="getType(item, 'right').approveBy" >
                    <b>{{$t('confirmBy')}}: </b> {{getType(item, 'right').approveBy.name}}
                  </div>
                </template>
                <template v-if="getType(item, 'right').cancelTime" >
                  <div>
                    <b>{{$t('cancelTime')}}: </b> {{getType(item, 'right').cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <div v-if="getType(item, 'right').approveBy" >
                    <b>{{$t('cancelBy')}}: </b> {{getType(item, 'right').approveBy.name}}
                  </div>
                </template>
                <div>
                  <span v-if="getType(item, 'right').cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
                  <span v-else-if="getType(item, 'right').confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
                  <span v-else-if="getType(item, 'right').submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
                  <span v-else class="mr-1 badge badge-warning">{{$t("doing")}}</span>

                  <span v-if="getType(item, 'right').note" class="text-gray-999 small" >{{getType(item, 'right').note}}</span>
                </div>
                <div v-if="getType(item, 'right').transcripts && getType(item, 'right').transcripts.length">
                  <div :class="[(getType(item, 'right').transcripts.join(', ').length <= 120 && getType(item, 'right').transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                    <div class="c-voice-text__content" v-html="getTranscripts(item, 'right')" ></div>
                    <div v-if="getType(item, 'right').transcripts.join(', ').length > 120 || getType(item, 'right').transcripts.length > 5" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                      <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                      <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                    </div>
                  </div>
                </div>
                <div class="mt-2" v-if="!item.finishTime && !getType(item, 'right').confirmTime">
                  <button type="button" class="btn btn-sm btn-primary mr-1" @click="update(getTypeString(item, 'right'), item)">
                    <i class="fa fa-edit mr-0"></i>
                    {{$t("edit")}}
                  </button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="lg" v-model="showForm" :title="formTitle" @ok="saveTranscript" no-close-on-backdrop no-enforce-focus>
      <template v-if="formModel.call">
        <p>
          <font-awesome-icon :class="iconClass(formModel.call)" size="2x" :icon="icon(formModel.call)" />
          {{ $t(formModel.call.direction) }} | <span>{{ formModel.call.hangupCause }}</span>
        </p>
        <p>
          <b>ID:&nbsp;</b><span>{{ formModel.call._id.toString() }}</span>
        </p>
        <p>
          <b>{{ $t('duration') }}:&nbsp;</b><span>{{ formModel.call.duration | callDuration }}</span>
        </p>
        <p>
          <b>{{ $t('billDuration') }}:&nbsp;</b><span>{{ formModel.call.billDuration | callDuration }}</span>
        </p>
        <app-audio v-if="formModel.call.recordingDownloaded" :id="formModel.call._id" :duration="formModel.call.duration" class="mb-2" />
      </template>
      <div v-if="formModel.type" class="alert alert-warning" :class="[['leftOne', 'leftTwo'].includes(formModel.type) ? 'alert-warning' : 'alert-info']">{{$t(formModel.type + 'Translate')}}</div>

      <form-array :label="$t('content')" :model="formModel" attribute="transcripts" :errors="formErrors" />
    </b-modal>
  </main>
</template>
<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import AppAudio from "@/components/AppAudio.vue";

export default {
  components: {AppAudio, TimeRangePicker},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/admin-call',
      tab: 0,
      defaultFilterFormModel: {
        time: "createTime",
        user: this.$store.state.user._id,
        status: null
      },
      autoLoad: true
    }
  },
  i18n: {
    messages: {
      en: {
        'callInfo': "Thông tin cuộc gọi",
        'leftOne': "Bên nhân viên",
        'rightOne': "Bên khách",
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        submit: "Chờ duyệt",
        canceled: "Từ chối",
        confirmed: "Đã duyệt",
        submitTime: "Dịch lúc",
        confirmTime: "Duyệt lúc",
        cancelTime: "Từ chối lúc",
        confirmBy: "Nhân viên duyệt",
        cancelBy: "Nhân viên từ chối",
        doing: "Đang dịch",
        seeMore: "Xem thêm",
        collapse: "Thu gọn",
        finish: "Hoàn thành",
        leftOneTranslate: "Chỉ dịch tiếng của nhân viên",
        leftTwoTranslate: "Chỉ dịch tiếng của nhân viên",
        rightOneTranslate: "Chỉ dịch tiếng của khách",
        rightTwoTranslate: "Chỉ dịch tiếng của khách",
        content: "Nội dung biên dịch"
      },
      vi: {
        'callInfo': "Thông tin cuộc gọi",
        'leftOne': "Bên nhân viên",
        'rightOne': "Bên khách",
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        submit: "Chờ duyệt",
        canceled: "Từ chối",
        confirmed: "Đã duyệt",
        submitTime: "Dịch lúc",
        confirmTime: "Duyệt lúc",
        cancelTime: "Từ chối lúc",
        confirmBy: "Nhân viên duyệt",
        cancelBy: "Nhân viên từ chối",
        doing: "Đang dịch",
        seeMore: "Xem thêm",
        collapse: "Thu gọn",
        finish: "Hoàn thành",
        leftOneTranslate: "Chỉ dịch tiếng của nhân viên",
        leftTwoTranslate: "Chỉ dịch tiếng của nhân viên",
        rightOneTranslate: "Chỉ dịch tiếng của khách",
        rightTwoTranslate: "Chỉ dịch tiếng của khách",
        content: "Nội dung biên dịch"
      }
    }
  },
  methods: {
    apply: function (data) {
      for(let item of data.docs){
        item.showMore = false
      }
      this.items = data.docs;
      this.itemCount = data.totalDocs;
    },
    icon(item) {
      if (item.direction === 'inbound') {
        return 'sign-in-alt';
      }
      if (item.direction === 'outbound') {
        return 'sign-out-alt';
      }
      if (item.direction === 'local') {
        return 'sync-alt';
      }
    },
    iconClass(item) {
      if (item.hangupCause === 'NORMAL_CLEARING') {
        return 'text-success';
      } else {
        return 'text-danger';
      }
    },
    getType(item, type) {
      if(type === 'left') {
        if(item.leftOne && item.leftOne.user && item.leftOne.user._id.toString() === this.$store.state.user._id.toString()) {
          return item.leftOne
        }
        if(item.leftTwo && item.leftTwo.user && item.leftTwo.user._id.toString() === this.$store.state.user._id.toString()) {
          return item.leftTwo
        }
      } else {
        if(item.rightOne && item.rightOne.user && item.rightOne.user._id.toString() === this.$store.state.user._id.toString()) {
          return item.rightOne
        }
        if(item.rightTwo && item.rightTwo.user && item.rightTwo.user._id.toString() === this.$store.state.user._id.toString()) {
          return item.rightTwo
        }
      }
    },
    getTypeString(item, type) {
      if(type === 'left') {
        if(item.leftOne && item.leftOne.user && item.leftOne.user._id.toString() === this.$store.state.user._id.toString()) {
          return 'leftOne'
        }
        if(item.leftTwo && item.leftTwo.user && item.leftTwo.user._id.toString() === this.$store.state.user._id.toString()) {
          return 'leftTwo'
        }
      } else {
        if(item.rightOne && item.rightOne.user && item.rightOne.user._id.toString() === this.$store.state.user._id.toString()) {
          return 'rightOne'
        }
        if(item.rightTwo && item.rightTwo.user && item.rightTwo.user._id.toString() === this.$store.state.user._id.toString()) {
          return 'rightTwo'
        }
      }
    },
    getTranscripts(item, type) {
      let data = this.getType(item, type);
      if(!data || !data.transcripts) {
        return  ''
      }
      return `<ul class="mb-0"><li>${data.transcripts.join('</li><li>')}</li></ul>`
    },
    saveTranscript: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      this.$service({url: `${this.service}/ctv-change/${this.formModel.id}`, method: "put", data: this.formModel}).then(response => {
        this.showForm = false;
        this.formModel = {};
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    update: function (type, item) {
      this.formModel = {};
      this.formTitle = this.$t('update');
      this.formErrors = [];
      this.showForm = true;
      this.formModel = {
        id: item._id,
        call: item.call,
        type: type,
        transcripts: item[type].transcripts
      };
    },
  }
}
</script>

<style lang="scss">
$white: #FFF;
$primary-color: #1284e7 !default;
@mixin transition-all($s){
  -webkit-transition:all $s ease;
  -moz-transition:all $s ease;
  transition:all $s ease;
}
@mixin linear-gradient($poi, $color1, $color2){
  background: linear-gradient($poi, $color1, $color2);
  background: -webkit-linear-gradient($poi, $color1, $color2); /* Firefox 3.6+ */
  background: -moz-linear-gradient($poi, $color1, $color2); /* IE 10 */
  background: -ms-linear-gradient($poi, $color1, $color2); /* Opera 11.10+ */
  background: -o-linear-gradient($poi, $color1, $color2);
}
.c-voice-text{
  &__content{
    font-size: 14px;
    line-height: 18px;
    overflow: hidden;
    max-height: 18px * 3;
    position: relative;
    z-index: 1;
    @include transition-all(0.2s);
    &:after{
      content: "";
      position: absolute;
      z-index: 2;
      bottom: 0;
      right: 0;
      left: 0;
      height: 18px;
      @include linear-gradient(to right, transparent, $white);
  }
    p{
      margin: 0;
  }
    .text-gray-999{
      position: relative;
      z-index: 4;
  }
}
  &__btn{
    padding-top: 5px;
    text-align: left;
}
  &__close{
    display: none;
    cursor: pointer;
    margin-right: 7px;
    font-size: 12px;
    color: $primary-color;
}
  &__expand{
    cursor: pointer;
    margin-right: 7px;
    font-size: 12px;
    color: $primary-color;
}
  &.active{
    .c-voice-text__content{
      max-height: none;
      &:after{
        display: none;
    }
  }
    .c-voice-text__expand{
      display: none;
  }
    .c-voice-text__close{
      display: inline;
  }
}
}
</style>